// extracted by mini-css-extract-plugin
module.exports = {"section":"GLOrderIntegralView_section__3Qe-r","sectionIcon":"GLOrderIntegralView_sectionIcon__G9ccT","sectionText":"GLOrderIntegralView_sectionText__1knfx"};